export default function Footer() {
  return (
    <footer>
      <p>
        This information is based on competition results owned and maintained by
        the{" "}
        <a href="https://worldcubeassociation.org/results">
          World Cube Association
        </a>{" "}
        as of June 12, 2021.
      </p>
    </footer>
  );
}
